import React from 'react';
import HistoricoVentasPorUsuario from '../components/HistoricoComponents/HistoricoVentasPorUsuario';
import Navbar from '../components/Navbar';

const HistoricoVentasPorUsuarioPage = () => {
  return (
    <div className="min-h-screen bg-blanco-puro">
      <Navbar />
      <HistoricoVentasPorUsuario />
    </div>
  );
};

export default HistoricoVentasPorUsuarioPage;
